/**
 * Centralized broker data — single source of truth.
 * All broker components import from here.
 * Managed by Forex-System automation.
 */
export const brokers = {
  xm: {
    name: 'XM',
    /* @replace:broker-xm */
      href: 'https://clicks.pipaffiliates.com/c?c=1275464&l=en&p=1',
  },
  tickmill: {
    name: 'Tickmill',
    /* @replace:broker-tickmill */
      href: 'https://my.tickmill.com?utm_campaign=ib_link&utm_content=IB15566262&utm_medium=Open+Account&utm_source=link&lp=https%3A%2F%2Fmy.tickmill.com%2Fen%2Fsign-up',
  },
  fxpro: {
    name: 'FxPro',
    /* @replace:broker-fxpro */
      href: 'https://direct-fxpro.com/en/partner/11378220',
  },
  icmarkets: {
    name: 'IC Markets',
    /* @replace:broker-ic-markets */
      href: 'https://www.vtmarkets.com/?affid=20541633',
  },
  axi: {
    name: 'Axi',
    /* @replace:broker-axi */
      href: 'https://www.axi.com/int/live-account?promocode=451380',
  },
  fxtm: {
    name: 'FXTM',
    /* @replace:broker-fxtm */
      href: 'https://forextime.com/?Referral=35407',
  },
} as const;

export type BrokerKey = keyof typeof brokers;